
/* Product Description Formatter - Converts plain text to proper HTML paragraphs */
document.addEventListener('DOMContentLoaded', function() {
  var descTab = document.querySelector('.product__info-as-bottom-tabs .dt-sc-tabs-content.rte');
  if (!descTab) return;
  
  var html = descTab.innerHTML;
  
  // Only process if content appears to be plain text (no <p> tags already)
  if (html.indexOf('<p>') > -1 || html.indexOf('<p ') > -1) return;
  
  // Collapse 3+ consecutive newlines into double newlines
  html = html.replace(/([ \t]*\n[ \t]*){3,}/g, '\n\n');
  
  // Split on double newlines to create paragraphs
  var parts = html.split(/\n\n+/);
  
  var formatted = parts
    .map(function(p) { return p.trim(); })
    .filter(function(p) { return p.length > 0; })
    .map(function(p) {
      if (p.match(/^<(div|p|h[1-6]|ul|ol|table|iframe|blockquote)/i)) return p;
      p = p.replace(/\n/g, '<br>');
      return '<p>' + p + '</p>';
    })
    .join('');
  
  descTab.innerHTML = formatted;
});
